export const ClubSymbols = {
    ClubProvider: Symbol.for("ClubProvider"),
    ClubService: Symbol.for("ClubService")
}